import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Form, Input } from "antd";

import { GetUrlParams, ObjectNumbersToEnglish } from "scripts/helpers";
import { updateUser } from "scripts/reducer";
import { Patterns } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import Icons from "scripts/icons";

const Component = ({ onUpdateUser }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { submitting } = state;
	const [form] = Form.useForm();
	const { search } = useLocation();
	const navigate = useNavigate();
	const { mobile } = GetUrlParams(search);

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				values = ObjectNumbersToEnglish(values);

				API.auth
					.login(values)
					.then(({ token, tokenExpirationDays, user }) => {
						API.setCookie(
							process.env.REACT_APP_COOKIE_TOKEN,
							token,
							tokenExpirationDays
						);
						onUpdateUser(user);

						navigate("/");
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidMount = () => {
		const { mobile } = GetUrlParams(search);

		if (Patterns.mobile.test(mobile)) {
			form.setFieldValue("phone", mobile);
		} else {
			navigate("/auth/status", { replace: true });
		}
	};

	useEffect(componentDidMount, []);

	return (
		<>
			<h1 className="heading">{`${Resources.enter} ${Resources.to} ${Resources.bakelid}`}</h1>
			<span className="text">{Resources.loginText}</span>
			<Form form={form} layout="vertical" requiredMark={false}>
				<Form.Item name="phone" label={Resources.mobile} rules={Rules.mobile}>
					<Input
						className="input-ltr"
						readOnly
						type="tel"
						size="large"
						placeholder={Resources.mobile}
						suffix={<Icons.Calling />}
					/>
				</Form.Item>
				<Form.Item
					name="password"
					label={Resources.password}
					rules={Rules.password}
				>
					<Input
						className="input-ltr"
						type="password"
						size="large"
						placeholder={Resources.password}
						suffix={<Icons.Lock />}
					/>
				</Form.Item>
				<Link to={`/auth/forgot?mobile=${mobile}`} className="forgot">
					{Resources.forgotPass}
				</Link>
			</Form>
			<div className="actions">
				<Button
					className="btn-default"
					size="large"
					disabled={submitting}
					onClick={() => navigate("/auth/status", { replace: true })}
				>
					{`${Resources.edit} ${Resources.mobile}`}
				</Button>
				<Button
					type="primary"
					size="large"
					loading={submitting}
					onClick={handleSubmit}
				>
					{Resources.enter}
				</Button>
			</div>
		</>
	);
};

export default connect(null, (dispatch) => {
	return {
		onUpdateUser: (data) => dispatch(updateUser(data)),
	};
})(Component);
